import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { KeyInfo } from './KeyInfo';
import { NRARulesLink } from './NRARulesLink';
import { ShootingDisciplines } from './ShootingDisciplines';
import { LeagueCosts } from './LeagueCosts';
import { CourseOfFire } from './CourseOfFire';
import { QuickLinks } from './QuickLinks';
export function PPCShootingPage() {
  return <PageLayout data-id="element-2607">
      <HeaderBanner data-id="element-2608" />
      <KeyInfo data-id="element-2609" />
      <NRARulesLink data-id="element-2610" />
      <ShootingDisciplines data-id="element-2611" />
      <LeagueCosts data-id="element-2612" />
      <CourseOfFire data-id="element-2613" />
      <QuickLinks data-id="element-2614" />
    </PageLayout>;
}